export default __webpack_public_path__ + "static/media/privacy-policy.142cea39.md";